import useNavModel, { RouterParamType } from '@/model/navModel'
import { Image, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { vehicleDetialModel } from './vehicleDetialModel'
import YhTootip from '@/components/YhTootip'
import { changeTime } from '@/utils/utils'
import ReactAudioPlayer from 'react-audio-player'
import { getBaseImgLookUrl } from '@/utils/constants'

// ...

// eslint-disable-next-line react-hooks/rules-of-hooks
export const ThreeInspectionDangerDetails = () => {
    const { getSelectedNavState } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    useEffect(() => {
        if (!detailsInfo?.id) return
        getOne(initPgCfg, detailsInfo.id, detailsInfo.dangerTab || 'scheduling')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailsInfo])
    const { initPgCfg, getOne, detailLookList } = vehicleDetialModel()

    const columns: any = [
        {
            title: '角色',
            width: 90,
            dataIndex: 'role',
            align: 'center',
        },
        {
            title: '车辆',
            width: 100,
            dataIndex: 'vehicleNumber',
            align: 'center',
            render: (text: string) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '司机',
            width: 90,
            dataIndex: 'driverName',
            align: 'center',
            render: (text: string) => <YhTootip text={text} style={{ width: '90px' }} />,
        },
        {
            title: '押运员',
            width: 100,
            dataIndex: 'escortName',
            align: 'center',
            render: (text: string) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '隐患项目',
            width: 180,
            dataIndex: 'itemName',
            align: 'center',
            render: (text: string) => <YhTootip text={text} style={{ width: '180px' }} />,
        },
        {
            title: '维修技师',
            width: 100,
            dataIndex: 'technicianName',
            align: 'center',
            render: (text: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined, res: { status: string }) => (
                <span>{res.status !== 'unallocated' ? text : ''}</span>
            ),
        },
        {
            title: '生成时间',
            width: 150,
            dataIndex: 'createTime',
            align: 'center',
            render: (text: any) => changeTime(text),
        },
        {
            title: '地点',
            width: 160,
            dataIndex: 'reportingLocation',
            align: 'center',
            render: (
                text: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined,
                res: {
                    status: string
                    role: string
                    repairLocation: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined
                    reportingLocation: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined
                },
            ) => (
                <span>
                    {res.status === 'unallocated' && res.role === '司机'
                        ? text
                        : (res.status === 'to.be.confirmed' && res.role === '维修技师') ||
                            (res.status === 'driver.to.be.confirmed' && (res.role === '管理员' || res.role === '超级管理员'))
                          ? res.repairLocation
                          : res.status === 'driver.to.be.confirmed' && (res.role === '管理员' || res.role === '超级管理员')
                            ? res.reportingLocation
                            : ''}
                </span>
            ),
        },
        {
            title: '描述',
            width: 160,
            dataIndex: 'faultDescription',
            align: 'center',
            render: (
                text: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined,
                res: { status: string; role: string; repairDescription: {} | null | undefined },
            ) => (
                <span>
                    {res.status === 'unallocated' && res.role === '司机'
                        ? text
                        : (res.status === 'to.be.confirmed' && res.role === '维修技师') ||
                            (res.status === 'driver.to.be.confirmed' && (res.role === '管理员' || res.role === '超级管理员'))
                          ? res.repairDescription
                          : res.status === 'driver.to.be.confirmed' && (res.role === '管理员' || res.role === '超级管理员')
                            ? res.repairDescription
                            : ''}
                </span>
            ),
        },
        // {
        //     title: '维修地点',
        //     width: 160,
        //     dataIndex: 'repairLocation',
        //     align: "center",
        //     render: (text,res) => <YhTootip text={res.status === 'to.be.confirmed'?text:''} style={{ width: '360px' }} />,
        // },        {
        //     title: '维修描述',
        //     width: 160,
        //     dataIndex: 'repairDescription',
        //     align: "center",
        //     render: (text,res) => <YhTootip text={res.status === 'to.be.confirmed'?text:''} style={{ width: '360px' }} />,
        // },
        {
            title: '图片',
            width: 300,
            dataIndex: 'repairDescription',
            align: 'center',
            render: (text: any, records: { status: string; role: string; driverPic: any[]; technicianPic: any[]; adminTechnicianPic: any[] }) => (
                <Image.PreviewGroup>
                    {records.status === 'unallocated' && records.role === '司机'
                        ? records.driverPic?.map((e) => <Image src={getBaseImgLookUrl(e)} style={{ maxHeight: '50px' }} />)
                        : records.status === 'to.be.confirmed' && records.role === '维修技师'
                          ? records.technicianPic?.map((e) => <Image src={getBaseImgLookUrl(e)} style={{ maxHeight: '50px' }} />)
                          : records.status === 'driver.to.be.confirmed' && (records.role === '管理员' || records.role === '超级管理员')
                            ? records.adminTechnicianPic?.map((e) => <Image src={getBaseImgLookUrl(e)} style={{ maxHeight: '50px' }} />)
                            : []}
                </Image.PreviewGroup>
            ),
        },
        // {
        //     title: '维修图片',
        //     width: 300,
        //     dataIndex: 'repairDescription',
        //     align: "center",
        //     render: (text, records) => <Image.PreviewGroup>{records.status === 'to.be.confirmed'?records.technicianPic?.map(e =><Image src={getBaseImgLookUrl(e)} width={90} style={{maxWidth:'50px'}} />):[]}</Image.PreviewGroup>
        // },
        {
            title: '录音',
            width: 300,
            dataIndex: 'tapeMd5',
            align: 'center',
            render: (text: string, records: { status: string; tapeMd5: any; role: string; trepairApeMd5: string }) =>
                records.status === 'unallocated' && records.tapeMd5 && records.role === '司机' ? (
                    <ReactAudioPlayer src={getBaseImgLookUrl(text)} controls />
                ) : records.status === 'to.be.confirmed' && records.tapeMd5 && records.role === '维修技师' ? (
                    <ReactAudioPlayer src={getBaseImgLookUrl(records.trepairApeMd5)} controls />
                ) : (
                    ''
                ),
        },
        // {
        //     title: '维修录音',
        //     width: 300,
        //     dataIndex: 'trepairApeMd5',
        //     align: "center",
        //     render: (text,records) => records.status === 'to.be.confirmed'&&records.trepairApeMd5&&<ReactAudioPlayer src={getBaseImgLookUrl(text)} controls/>
        // },
        {
            title: '签名',
            width: 140,
            align: 'center',
            render: (text: any, records: { signMd5: string }) => <Image src={getBaseImgLookUrl(records.signMd5)} style={{ maxHeight: '50px' }} />,
        },
    ]

    return (
        <>
            <div style={{ backgroundColor: '#fff', height: 'calc(100vh - 110px)' }}>
                <span style={{ margin: '20px', lineHeight: '60px', fontWeight: 'bolder', fontSize: '30px', color: '#767676' }}>隐患详情</span>

                <Table
                    rowKey={(record) => record.id}
                    // rowClassName={(record) => {
                    //     debugger
                    //     if (record?.repairAddress=='天津市津南区天津津南开发区旺港路15号津交富港物流公司') return "background-b6b3b3";
                    //     return ""
                    // }}

                    columns={columns}
                    scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
                    dataSource={detailLookList}
                    pagination={false}
                    bordered
                    style={{ margin: '0 10px' }}
                />
            </div>
        </>
    )
}
